export default "/images/vendor/@coreui/icons/svg/flag/cif-gm.svg?042d7c3d07c947a1bb3eaeb2a1e64e22";